"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLanguage = exports.fMultilanguage = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const fMultilanguage = (value, locale) => {
    var _a;
    // TODO think. Not sure. Perhaps should be returned undefined in second case
    return value ? (_a = value[locale]) !== null && _a !== void 0 ? _a : value[Object.keys(value)[0]] : undefined;
};
exports.fMultilanguage = fMultilanguage;
// TODO embed in other places with displaying multilanguage names
const MultiLanguage = (props) => {
    const { value } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("span", null, (0, exports.fMultilanguage)(value, locale)));
};
exports.MultiLanguage = MultiLanguage;
//# sourceMappingURL=index.js.map